import { render, staticRenderFns } from "./paymant.vue?vue&type=template&id=57d4f543&scoped=true"
import script from "./paymant.vue?vue&type=script&lang=js"
export * from "./paymant.vue?vue&type=script&lang=js"
import style0 from "./paymant.vue?vue&type=style&index=0&id=57d4f543&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d4f543",
  null
  
)

export default component.exports